var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7501 15.9603C16.2634 15.586 19 12.6126 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.6127 7.73672 15.5861 11.2501 15.9603V22C11.2501 22.4142 11.5859 22.75 12.0001 22.75C12.4143 22.75 12.7501 22.4142 12.7501 22V15.9603ZM12.7501 15.9603C12.5036 15.9865 12.2534 16 12 16C11.7467 16 11.4965 15.9865 11.2501 15.9603V13.4014L8.58405 11.624C8.23941 11.3943 8.14628 10.9286 8.37604 10.584C8.60581 10.2393 9.07146 10.1462 9.4161 10.376L11.2501 11.5986V9C11.2501 8.58579 11.5859 8.25 12.0001 8.25C12.4143 8.25 12.7501 8.58579 12.7501 9V11.5986L14.5841 10.376C14.9287 10.1462 15.3944 10.2393 15.6241 10.584C15.8539 10.9286 15.7608 11.3943 15.4161 11.624L12.7501 13.4014V15.9603Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeAlt1);
export default __webpack_public_path__ + "static/media/tree-alt-1.7f9f6a49ddb29c479bac18fb086abfd6.svg";
export { ForwardRef as ReactComponent };